import { HTTPStatus } from './ErrorEnums.ts';
import { ErrorDefault } from './Errors.ts';
import { SharedStrings } from '@colonist/types';
import { DISCORD_CHANNEL } from '@colonist/consts';
(function(ErrorsMatchmaking) {
    class AlreadySearchingForMatch extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.matchmakingError.title'
            };
            const message = {
                key: 'strings:popups.errors.matchmakingError.alreadySearchingForMatch'
            };
            const httpStatus = HTTPStatus.Conflict;
            super(title, message, httpStatus);
        }
    }
    ErrorsMatchmaking.AlreadySearchingForMatch = AlreadySearchingForMatch;
    class InternalServerError extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.matchmakingError.title'
            };
            const message = {
                key: 'strings:popups.errors.matchmakingError.internalServerError',
                options: {
                    email: SharedStrings.SUPPORT_EMAIL
                }
            };
            const httpStatus = HTTPStatus.InternalServerError;
            super(title, message, httpStatus);
        }
    }
    ErrorsMatchmaking.InternalServerError = InternalServerError;
    class InvalidRequest extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.matchmakingError.title'
            };
            const message = {
                key: 'strings:popups.errors.matchmakingError.invalidRequest'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsMatchmaking.InvalidRequest = InvalidRequest;
    class RankedLocked extends ErrorDefault {
        constructor(gamesPlayed, gamesRequired){
            const title = {
                key: 'strings:popups.errors.matchmakingInfo.title'
            };
            const message = {
                key: 'strings:popups.errors.matchmakingInfo.playMoreToUnlockRanked',
                options: {
                    finishedGames: gamesPlayed,
                    totalRequiredGames: gamesRequired,
                    gamesNeeded: gamesRequired - gamesPlayed
                }
            };
            const httpStatus = HTTPStatus.ServiceUnavailable;
            super(title, message, httpStatus);
        }
    }
    ErrorsMatchmaking.RankedLocked = RankedLocked;
    class ShuffleLocked extends ErrorDefault {
        constructor(gamesPlayed, gamesRequired){
            const title = {
                key: 'strings:popups.errors.matchmakingInfo.title'
            };
            const message = {
                key: 'strings:popups.errors.matchmakingInfo.playMoreToUnlockShuffle',
                options: {
                    finishedGames: gamesPlayed,
                    totalRequiredGames: gamesRequired,
                    gamesNeeded: gamesRequired - gamesPlayed
                }
            };
            const httpStatus = HTTPStatus.ServiceUnavailable;
            super(title, message, httpStatus);
        }
    }
    ErrorsMatchmaking.ShuffleLocked = ShuffleLocked;
    class ServerUpdating extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.matchmakingError.title'
            };
            const message = {
                key: 'strings:colonistCommon.serverStatus.serverUpdating',
                options: {
                    discordLink: DISCORD_CHANNEL
                }
            };
            const httpStatus = HTTPStatus.ServiceUnavailable;
            super(title, message, httpStatus);
        }
    }
    ErrorsMatchmaking.ServerUpdating = ServerUpdating;
    class AlreadyPlayingRankedGame extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.matchmakingError.title'
            };
            const message = {
                key: 'strings:popups.errors.matchmakingError.alreadyPlayingRankedGame'
            };
            const httpStatus = HTTPStatus.Conflict;
            super(title, message, httpStatus);
        }
    }
    ErrorsMatchmaking.AlreadyPlayingRankedGame = AlreadyPlayingRankedGame;
    class InvalidRankedMode extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.matchmakingError.title'
            };
            const message = {
                key: 'strings:popups.errors.matchmakingError.invalidRankedMode'
            };
            const httpStatus = HTTPStatus.BadRequest;
            super(title, message, httpStatus);
        }
    }
    ErrorsMatchmaking.InvalidRankedMode = InvalidRankedMode;
    class QueueUpdating extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.matchmakingError.queueUpdating.title'
            };
            const message = {
                key: 'strings:popups.errors.matchmakingError.queueUpdating.body'
            };
            const httpStatus = HTTPStatus.ServiceUnavailable;
            super(title, message, httpStatus);
        }
    }
    ErrorsMatchmaking.QueueUpdating = QueueUpdating;
    class NoFreeGamesRemaining extends ErrorDefault {
        constructor(){
            const title = {
                key: 'strings:popups.errors.matchmakingError.noFreeGamesRemaining.title'
            };
            const message = {
                key: 'strings:popups.errors.matchmakingError.noFreeGamesRemaining.body'
            };
            const httpStatus = HTTPStatus.Forbidden;
            super(title, message, httpStatus);
        }
    }
    ErrorsMatchmaking.NoFreeGamesRemaining = NoFreeGamesRemaining;
})(ErrorsMatchmaking || (ErrorsMatchmaking = {}));
export var ErrorsMatchmaking;
